// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-cat-js": () => import("./../../../src/pages/cat.js" /* webpackChunkName: "component---src-pages-cat-js" */),
  "component---src-pages-dog-js": () => import("./../../../src/pages/dog.js" /* webpackChunkName: "component---src-pages-dog-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-long-page-js": () => import("./../../../src/pages/long-page.js" /* webpackChunkName: "component---src-pages-long-page-js" */)
}

